import React from "react";
import { Form } from "react-bootstrap";

//USA PIC COME PROPS PER COLLEGARE LO STATO DELL'IMMAGINE NEL FILE PRINCIPALE ES:
//pic = {*nome stato utilizzato*} setPic = {*nome setter stato*} id={*name campo*} name={*nome campo*} id={"ricettaMedica"} name={"ricettaMedica"}

export const InputFile = (props) => (
  <div className="custom-file">
    <Form.File
      type="file"
      accept="application/pdf"
      className="custom-file-input"
      name={props.name}
      id={props.id}
      style={{ visibility: "hidden" }}
      onChange={(e) => props.setFile(e.target.files[0])}
    />
    <label
      className={`col-12 custom-file-label ${!props.file ? "text-muted" : null}`}
      htmlFor={props.id}
    >
      {props.file ? props.file.name : "Seleziona file (pdf)"} 
    </label>
  </div>
);
